export const shouldLoad = () => document.querySelector('[data-controller="card-section"]') !== undefined;